import * as React from 'react';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import List from '@mui/material/List';
import { Link } from 'react-router-dom';
import { routes } from '../../Routes';
import { ContentPage, IPageContent, TContentState } from '../../types/Content';
import { IAppState } from '../../store/Store';
import { useSelector } from 'react-redux';
import ListItemIcon from '@mui/material/ListItemIcon';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import { getMenuItemIcon, pageContent } from '../../helpers/menu';

interface INavbarItemListProps {
  close: () => void;
}

const useStyles = makeStyles((theme: Theme) => ({
  icon: {
    minWidth: '35px',
    marginTop: '3px',
  },
  external: {
    padding: '4px 16px',
    textDecoration: 'none',
    color: 'inherit',
  },
  item: {
    display: 'flex',
    alignItems: 'flex-start',
    paddingTop: '4px',
    paddingBottom: '4px',
    wordBreak: 'break-word',
    '&.MuiListItem-root': {
      width: '100%',
    },
  },
}));

const NavbarItemList: React.FC<INavbarItemListProps> = (props): JSX.Element => {
  const contentState: TContentState = useSelector<IAppState, TContentState>(
    (state) => state.contentState
  );
  const classes = useStyles({});

  const renderListItem = (page: IPageContent) => {
    const isExternalLink = page.type === ContentPage.MENU_LINK;

    const listItemContent = (
      <>
        <ListItemIcon className={classes.icon} children={getMenuItemIcon(page)} />
        <ListItemText primary={page.name} />
      </>
    );

    if (isExternalLink && page.linkUrl) {
      return (
        <a
          href={page.linkUrl}
          target={page.linkNewWindow ? '_blank' : ''}
          rel="noopener noreferrer"
          className={`${classes.item} ${classes.external} MuiListItem-root`}
          onClick={props.close}
        >
          {listItemContent}
        </a>
      );
    } else {
      return (
        <ListItem
          button
          component={Link}
          to={page.id ? pageContent(page) : routes.home}
          onClick={props.close}
          className={classes.item}
        >
          {listItemContent}
        </ListItem>
      );
    }
  };

  return (
    <List>
      {contentState.customPages?.map((page) => {
        if (page.type === ContentPage.WHISTLEBLOWER) return null;
        return (
          <div key={page.id}>
            {renderListItem(page)}
          </div>
        );
      })}
    </List>
  );
};

export default NavbarItemList;